import React from 'react';
import { useGetPaginatedDronesQuery } from '@src/core/features/drone/redux';
import { ArcSocketContext, ChannelResponseEnum } from '@src/core/socket';

interface UsePaginatedDronesOptions {
  initialPage?: number;
  initialSize?: number;
  sort?: string[];
}

export const usePaginatedDrones = (options: UsePaginatedDronesOptions = {}) => {
  const { initialPage = 0, initialSize = 10, sort } = options;
  
  const [page, setPage] = React.useState(initialPage);
  const [size, setSize] = React.useState(initialSize);
  
  const { subscribe, unsubscribe } = React.useContext(ArcSocketContext);
  
  const { data, isLoading, isFetching, refetch } = useGetPaginatedDronesQuery({
    page,
    size,
    sort,
  });

  React.useEffect(() => {
    subscribe(ChannelResponseEnum.UPDATE_DRONES, () => refetch());
    return () => unsubscribe(ChannelResponseEnum.UPDATE_DRONES);
  }, [refetch, subscribe, unsubscribe]);

  const handlePageChange = React.useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const handleSizeChange = React.useCallback((newSize: number) => {
    setSize(newSize);
    setPage(0);
  }, []);

  return {
    drones: data?.data ?? [],
    isLoading,
    isFetching,
    refetch,
    pagination: {
      page,
      size,
      totalCount: data?.totalCount ?? 0,
      onPageChange: handlePageChange,
      onSizeChange: handleSizeChange,
    },
  };
};
